/**
 * Calculate the scroll bar width of the browser
 */
export function getScrollbarWidth() {
	let outer = document.createElement("div");
	outer.style.visibility = "hidden";
	outer.style.width = "100px";
	outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps

	document.body.appendChild(outer);

	let widthNoScroll = outer.offsetWidth;
	// force scrollbars
	outer.style.overflow = "scroll";

	// add innerdiv
	let inner = document.createElement("div");
	inner.style.width = "100%";
	outer.appendChild(inner);

	let widthWithScroll = inner.offsetWidth;

	// remove divs
	outer.parentNode.removeChild(outer);

	return widthNoScroll - widthWithScroll;
}

/**
 * Get the browsers current viewport width
 */
export function getViewportWidth() {
	return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
}

/**
 * Get the browsers current viewport height
 */
export function getViewportHeight() {
	return Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
}

/**
 * Function to debounce a function if run in quick successtion. If the function is called again before the timer ends it will clear it's. Only until
 * after the delay has expired will the func(tion) passed be called
 *
 * @param {Function} func - the function to run after debouncing
 * @param {object} timer - object with the timers
 * @param {string} key - the timer key to use
 * @param {int} delay - the delay in ms
 */
export function _debounce(fn, time) {
	let timeout;
	return function () {
		const functionCall = () => fn.apply(this, arguments);

		clearTimeout(timeout);
		timeout = setTimeout(functionCall, time);
	};
}

export function _throttle(func, wait) {
	let throttle = false
	return function (...args) {
		if (!throttle) {
			func.apply(this, args);
			throttle = true;
			setInterval(() => { throttle = false }, wait)
		}
	}
}

/**
 * Determine if passed variable is a function
 *
 * @param {*} func
 */
export function isFunction(func) {
	return func && {}.toString.call(func) === '[object Function]';
}


/**
 * File skip-link-focus-fix.js.
 *
 * Helps with accessibility for keyboard only users.
 */
export function skipLinkFocus() {
	let isWebkit = navigator.userAgent.toLowerCase().indexOf('webkit') > -1;
	let isOpera = navigator.userAgent.toLowerCase().indexOf('opera') > -1;
	let isIe = navigator.userAgent.toLowerCase().indexOf('msie') > -1;

	if ((isWebkit || isOpera || isIe) && document.getElementById && window.addEventListener) {
		window.addEventListener(
			'hashchange',
			function () {
				let id = location.hash.substring(1),
					element;

				if (!(/^[A-z0-9_-]+$/.test(id))) {
					return;
				}

				element = document.getElementById(id);

				if (element) {
					if (!(/^(?:a|select|input|button|textarea)$/i.test(element.tagName))) {
						element.tabIndex = -1;
					}

					element.focus();
				}
			},
			false
		);
	}
}

export function mergeObject(obj, defaultObj) {
	for (var prop in obj) {
		if (obj.hasOwnProperty(prop)) {
			// Push each value from `obj` into `extended`
			defaultObj[prop] = obj[prop];
		}
	}

	return defaultObj;
}

export function createElementFromString(string) {
	const element = new DOMParser().parseFromString(string, 'text/html');
	return element.body.childNodes[0];
}

export function attachEventToBody(element, callbackFn, _this = '') {
	document.getElementsByTagName('body')[0].addEventListener(
		'click',
		(event) => {
			for (let el of document.querySelectorAll(element)) {
				if (el.contains(event.target)) {
					callbackFn(el, _this);
				}
			}
		}
	)
}

export function disableScroll() {
	// Get the current page scroll position
	let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	let scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

	// if any scroll is attempted, set this to the previous value
	window.onscroll = function () {
		window.scrollTo(scrollLeft, scrollTop);
	};
}

export function enableScroll() {
	window.onscroll = function () { };
}

export function copyToClipboard() {
	$(document.body).on('click', '.copy-to-clipboard', async function (e) {
		e.preventDefault();

		const that = this;
		if (that.dataset.copying === 'true') {
			return;
		}

		that.dataset.copying = true;

		const overlay = createElementFromString(
			`<span style="
				padding:10px;
				border-radius:10px;
				position:absolute;
				inset: 0px;
				opacity:1;
				z-inder:10;
			">
				<span style="
					padding: 10px;
					border: 2px dashed;
					border-radius: 6px;
					text-transform: uppercase;
					letter-spacing: 0.05em;
					height: 100%;
					display: flex;
					align-items: center;
					justify-content: center;
					font-size: inherit;
				"></span>
			</span>`
		)

		try {
			if (!navigator.clipboard) {
				throw 'failed';
			}
			const text = that.textContent.replace(/(\r\n|\n|\r|\t)/gm, "");
			await navigator.clipboard.writeText(text);


			overlay.style.background = '#77a464';
			overlay.children[0].style.borderColor = '#396826';
			overlay.children[0].style.color = '#396826';
			overlay.children[0].textContent = 'copied';

		} catch (err) {
			overlay.style.background = '#a94442';
			overlay.children[0].style.borderColor = '#621f1d';
			overlay.children[0].style.color = '#621f1d';
			overlay.children[0].textContent = 'Failed to copy';
		} finally {
			const original_pos = that.style.position;
			that.style.position = 'relative';

			that.appendChild(overlay);
			setTimeout(() => {
				overlay.style.transition = 'opacity 0.3s';
				overlay.style.opacity = '0';

				setTimeout(() => {
					that.style.position = original_pos;
					overlay.remove();
					that.dataset.copying = false;
				}, 300);
			}, 2000)
		}
	});
}

export function validateCommentSubmission() {
	jQuery('#commentform').on('submit', function (e) {

		let errors = [];

		jQuery(this).find('[required]').each(function () {
			if (!jQuery(this).val()) {
				errors.push({
					element: jQuery(this),
					message: '<strong class="text-uppercase">' + jQuery(this).parents('p').find('label').get(0).childNodes[0].textContent + '</strong> is required'
				});
			} else if (this.type === 'email' && ! /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(jQuery(this).val())) {
				errors.push({
					element: $(this),
					message: '<strong class="text-uppercase">' + jQuery(this).parents('p').find('label').get(0).childNodes[0].textContent + '</strong> is an invalid email address'
				});
			}
		});

		if (errors.length) {
			e.preventDefault();
			jQuery('#commentform-errors').show().find('ul').empty();
			errors.forEach(err => {
				jQuery('#commentform-errors ul').append(`<li>${err.message}</li>`)
			});
			return;
		}

		jQuery('#commentform-errors').hide();
	});
}

export function setCurrentMenuItemClass() {
	const menuItems = document.querySelectorAll('.wp-block-navigation-item');
	if (!menuItems.length) {
		return;
	}

	// Check for .current-menu-item class on any item and stop if found.
	for (let i = 0; i < menuItems.length; i++) {
		if (menuItems[i].classList.contains('current-menu-item')) {
			menuItems[i].classList.remove('current-menu-item');
			// return;
		}
	}

	// Add trailing slash to path if missing.
	let url = window.location.href.endsWith('/')
		? window.location.href
		: `${window.location.href}/`;
	url = url.replace(/https?:\/\//g, "");

	let matched = false;
	let i = 0;

	do {
		// Check for matching URL path on any child link of menuItems.
		for (let i = 0; i < menuItems.length; i++) {
			const link = menuItems[i].querySelector('a');
			let linkURL = link.href.endsWith('/')
				? link.href
				: `${link.href}/`;
			linkURL = linkURL.replace(/https?:\/\//g, "");

			// Note: link.href returns full URL, even if it's a relative link.
			if (linkURL === url) {
				menuItems[i].classList.add('current-menu-item');
				matched = true;
				break;
			}
		}

		let index = url.replace(/\/$/, "").lastIndexOf('/');

		if (index === -1 || i > 10) {
			matched = true;
			break;
		}

		url = url.substring(0, index + 1);
		i++;
	} while (matched === false)

}